// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnauthorizedPopup_container__0-oPI .UnauthorizedPopup_main-message__S8h4X {
  font-size: 20px;
  padding-top: 30px;
}
.UnauthorizedPopup_container__0-oPI .UnauthorizedPopup_sub-message__Z8vyz {
  font-size: 14px;
}
.UnauthorizedPopup_container__0-oPI .UnauthorizedPopup_sub-message-error__xkYKO {
  font-size: 14px;
  color: #e15b5c;
}
.UnauthorizedPopup_container__0-oPI .UnauthorizedPopup_buttons-wrapper__Z8yGa {
  padding-top: 30px;
  margin-bottom: -50px;
  min-width: 420px;
}
.UnauthorizedPopup_container__0-oPI .UnauthorizedPopup_buttons-wrapper__Z8yGa Button {
  margin: auto;
}
.UnauthorizedPopup_container__0-oPI img {
  margin-top: -25px;
}`, "",{"version":3,"sources":["webpack://./src/components/App/UnauthorizedPopup/UnauthorizedPopup.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAIE;EACE,eAAA;EACA,iBAAA;AAHJ;AAME;EACE,eCTK;ADKT;AAOE;EACE,eCbK;EDcL,cAAA;AALJ;AAQE;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AANJ;AAQI;EACE,YAAA;AANN;AAUE;EACE,iBAAA;AARJ","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.container {\n  .main-message {\n    font-size: 20px;\n    padding-top: 30px;\n  }\n\n  .sub-message {\n    font-size: typography.$body-m;\n  }\n\n  .sub-message-error {\n    font-size: typography.$body-m;\n    color: #e15b5c;\n  }\n\n  .buttons-wrapper {\n    padding-top: 30px;\n    margin-bottom: -50px;\n    min-width: 420px;\n\n    Button {\n      margin: auto;\n    }\n  }\n\n  img {\n    margin-top: -25px;\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UnauthorizedPopup_container__0-oPI`,
	"main-message": `UnauthorizedPopup_main-message__S8h4X`,
	"sub-message": `UnauthorizedPopup_sub-message__Z8vyz`,
	"sub-message-error": `UnauthorizedPopup_sub-message-error__xkYKO`,
	"buttons-wrapper": `UnauthorizedPopup_buttons-wrapper__Z8yGa`
};
export default ___CSS_LOADER_EXPORT___;
